__turbopack_context__.v({
  "card": "TestsShowcaseSection-module__EjAcca__card",
  "cardDescription": "TestsShowcaseSection-module__EjAcca__cardDescription",
  "cardTag": "TestsShowcaseSection-module__EjAcca__cardTag",
  "cardTitle": "TestsShowcaseSection-module__EjAcca__cardTitle",
  "content": "TestsShowcaseSection-module__EjAcca__content",
  "ctaContainer": "TestsShowcaseSection-module__EjAcca__ctaContainer",
  "locationDisclaimer": "TestsShowcaseSection-module__EjAcca__locationDisclaimer",
  "root": "TestsShowcaseSection-module__EjAcca__root",
  "subtitle": "TestsShowcaseSection-module__EjAcca__subtitle",
  "testListContainer": "TestsShowcaseSection-module__EjAcca__testListContainer",
  "title": "TestsShowcaseSection-module__EjAcca__title",
});
